import React, { useContext, useEffect, useMemo, useState } from 'react'

import { TIMESTAMP_KEYS } from 'constants/app'
import { APPLICATION_STATUS_ACTIONS } from 'constants/application-status'
import { AppContext } from 'contexts/AppContext'
import { apiManager } from 'helpers'
import { getProfileActivities } from 'helpers/application-status'
import { useQuery } from 'hooks'

import MembershipModal from 'components/MembershipModal'

const PaymentCheck = ({ user }) => {
  const { timestamps, updateTimestamp } = useContext(AppContext)
  const [showMembershipModal, setShowMembershipModal] = useState(false)
  const { data: applicationStatusData, refetch: refetchApplicationStatus } = useQuery(
    'user/applicationStatus',
    apiManager.getApplicationStatus,
    {
      enabled: !user.admin,
    }
  )

  const { isPaymentComplete, isProfileComplete } = useMemo(() => {
    const isPaymentComplete = applicationStatusData?.activities.find(
      ({ action }) => action === APPLICATION_STATUS_ACTIONS.SAVE_PAYMENT
    )?.completed
    const isProfileComplete =
      getProfileActivities(applicationStatusData?.activities).filter(({ completed }) => !completed)
        .length === 0

    return {
      isPaymentComplete,
      isProfileComplete,
    }
  }, [applicationStatusData])

  useEffect(() => {
    if (typeof isPaymentComplete === 'undefined') {
      return
    }

    setShowMembershipModal(!isPaymentComplete)
  }, [isPaymentComplete, applicationStatusData])

  const profileCompletedTimestamp = timestamps[TIMESTAMP_KEYS.PROFILE_COMPLETED]
  useEffect(() => {
    setTimeout(() => {
      refetchApplicationStatus()
    }, 1000)
  }, [user.updatedAt, profileCompletedTimestamp, refetchApplicationStatus])

  if (!applicationStatusData) {
    return null
  }

  return (
    <MembershipModal
      show={showMembershipModal}
      onClose={isProfileComplete ? null : () => setShowMembershipModal(false)}
      onComplete={() => {
        setShowMembershipModal(false)
        updateTimestamp(TIMESTAMP_KEYS.PROFILE_COMPLETED)
      }}
    />
  )
}

export default PaymentCheck
